var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.125 19.375C17.0245 19.375 19.375 17.0245 19.375 14.125C19.375 11.2255 17.0245 8.875 14.125 8.875C11.2255 8.875 8.875 11.2255 8.875 14.125C8.875 17.0245 11.2255 19.375 14.125 19.375Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.25 14.125C27.25 25.9375 14.125 35.125 14.125 35.125C14.125 35.125 1 25.9375 1 14.125C1 10.644 2.38281 7.30564 4.84422 4.84422C7.30564 2.38281 10.644 1 14.125 1C17.606 1 20.9444 2.38281 23.4058 4.84422C25.8672 7.30564 27.25 10.644 27.25 14.125V14.125Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/mapPin.c00c3b5e071c09bcb3d47c9d40315999.svg";
export { ForwardRef as ReactComponent };